import { CARD_TYPE_MAP } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';

/**
 * ALL VALUES HERE MUST ALREADY BE IN LEAD_CARD_TYPES.
 *
 * Typically identical to LEAD_CARD_TYPES, but keeps web-wedding from breaking when a new card types is added in zola-ui.
 *
 * As soon as a new type is added here, corresponding card data will need to be added
 * around web-wedding. Use `npm run check` to find any places missing new card type data.
 */
export const SUPPORTED_LEAD_CARD_TYPES = [
  CARD_TYPE_MAP.bellyBand,
  CARD_TYPE_MAP.vellumJacket,
  CARD_TYPE_MAP.waxSeal,
  CARD_TYPE_MAP.paperAddOns,
  CARD_TYPE_MAP.ctd,
  CARD_TYPE_MAP.details,
  CARD_TYPE_MAP.dstd,
  CARD_TYPE_MAP.enclosure,
  CARD_TYPE_MAP.holiday,
  CARD_TYPE_MAP.invitation,
  CARD_TYPE_MAP.matchingSuites,
  CARD_TYPE_MAP.menu,
  CARD_TYPE_MAP.napkin,
  CARD_TYPE_MAP.place,
  CARD_TYPE_MAP.program,
  CARD_TYPE_MAP.signage,
  CARD_TYPE_MAP.std,
  CARD_TYPE_MAP.sticker,
  CARD_TYPE_MAP.tableNumber,
  CARD_TYPE_MAP.thankyou,
  CARD_TYPE_MAP.weddingShower,
] as const;

export type SupportedLeadCardType = typeof SUPPORTED_LEAD_CARD_TYPES[number];

export const isSupportedLeadCardType = (type?: string): type is SupportedLeadCardType => {
  if (!type) return false;
  return (SUPPORTED_LEAD_CARD_TYPES as Readonly<string[]>).includes(type);
};
